<app-search-bar [filters]="filters" [showPrimaryBtn]="false"
  (formValueChange)="handleFormValueChange($event)"></app-search-bar>

<ng-container *ngIf="loadCampanhas; else SetData">
  <app-skeleton-loader [count]="5" type="card-campanha-dash"></app-skeleton-loader>
</ng-container>

<ng-template #SetData>
  <ng-container *ngIf="pagination.data?.length; else noData">
    <div class="list" *ngFor="let item of pagination.data">
      <app-card-campanha-dash-admin [campanha]="item" [codigo]="item.id" [titulo]="item.titulo"
        [Sector]="item?.categoria?.descricao" [Objectivo]="item.metaArrecadar" [Arrecadado]="item.valorArrecado"
        [estado]="item.estadoCampanha" [DataCriacao]="item.dataCriacaoFormatada" [actions]="getActionsByEstado(item)"
        (rowClick)="verDetalhe(item)" (menuOpened)="setOpenedMenu($event)"></app-card-campanha-dash-admin>
    </div>

    <div class="pagination-controls">
      <app-paginator-control [first]="
          ((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)
        " [rows]="pagination.pageSize ?? 10" [totalRecords]="pagination.totalRecords ?? 0"
        (pageChange)="onPageChange($event)">
      </app-paginator-control>
    </div>
  </ng-container>
</ng-template>

<ng-template #noData>
  <div class="no-data">
    <app-data-void titulo="Nenhuma campanha encontrada" descricao="Tente novamente mais tarde."></app-data-void>
  </div>
</ng-template>

<p-drawer [(visible)]="visible" position="right" [style]="{ width: '780px', maxWidth: '95vw' }"
  styleClass="!w-full md:!w-80 lg:!w-[48.75rem]" appendTo="body" [blockScroll]="true" [modal]="true">
  <ng-template #headless>
    <div class="drawer-body-wrapper">
      @if (campanha) {
      <app-admin-detalhe-campanha [campanha]="campanha" (onCloseModal)="visible = false" />
      }
    </div>
  </ng-template>
</p-drawer>

<p-dialog header="Exportar Relatório" [modal]="true" [(visible)]="showModalFiter" [style]="{ width: '35rem' }">
  <form class="p-fluid grid" [formGroup]="formFilter">
    <div class="field col-6 flex flex-column gap-2">
      <label for="ValorApoio">Valor do Apoio</label>
      <p-inputNumber formControlName="ValorApoio" [style.width]="'230px'" />
    </div>

    <div class="field col-6 flex flex-column gap-2">
      <label for="EstadoApoioENUM">Estado do Apoio</label>
      <p-select formControlName="EstadoApoioENUM" appendTo="body" placeholder="Seleccione o estado" optionLabel="label"
        optionValue="id" [options]="estadoApoioList" />
    </div>

    <div class="field col-6 flex flex-column gap-2">
      <label for="Ativo">Campanha Activa</label>
      <p-select formControlName="Ativo" appendTo="body" placeholder="Seleccione o estado" optionLabel="label"
        optionValue="value" [options]="activeList" />
    </div>
  </form>

  <div class="flex justify-content-between gap-2">
    <p-button label="Cancelar" severity="secondary" (click)="closeModalFilter()" />
    <p-button severity="success" (click)="exportarRelatorio()" [disabled]="loadFilters">
      {{ loadFilters ? "Exportando relatório..." : "Exportar Relatório" }}
      <i class="pi pi-spin pi-spinner" *ngIf="loadFilters"></i>
    </p-button>
  </div>
</p-dialog>

<p-dialog header="Realizar apoio manual" [modal]="true" [(visible)]="showDialogApoioManual"
  (onHide)="closeDialogApoioManual()" [style]="{ width: '35rem' }">
  <h3 class="tittle_apoio">Campanha: {{ campanhaSelecionada?.titulo }}</h3>
  <br />
  <form class="p-fluid grid" [formGroup]="formApoioManual">
    <div class="field col-12 flex flex-column gap-2">
      <label for="utilizadorID">Utilizador</label>
      <p-select formControlName="utilizadorID" appendTo="body" placeholder="Seleccione o utilizador" optionLabel="label"
        optionValue="value" [options]="utilizadoresList" filter="true" showClear="true" />
      <small class="error" *ngIf="isInvalidApoio('utilizadorID')">Utilizador é obrigatório.</small>
    </div>

    <div class="field col-6 flex flex-column gap-2">
      <label for="TipoApoio">Tipo de apoio</label>
      <p-select formControlName="TipoApoio" appendTo="body" placeholder="Seleccione o tipo de apoio" optionLabel="label"
        optionValue="value" [options]="typeApoioOptions" />
      <small class="error" *ngIf="isInvalidApoio('TipoApoio')">Tipo de apoio é obrigatório.</small>
    </div>

    <div class="field col-6 flex flex-column gap-2">
      <label for="ValorApoio">Valor do Apoio</label>
      <p-inputNumber formControlName="ValorApoio" [style.width]="'230px'" />
      <small class="error" *ngIf="isInvalidApoio('ValorApoio')">Valor do apoio é obrigatório.</small>
    </div>

    <div *ngIf="IsrecompensaCampanha" class="recompensas_section mt-1 mb-2 px-2">
      <p class="info-text">
        Esta campanha oferece recompensas. Escolha uma recompensa para apoiar a
        campanha.
      </p>

      <div class="lista-recompensas">
        <div class="recompensa-card" *ngFor="let recompensa of campanhaSelecionada?.recompensa"
          (click)="selecionarRecompensa(recompensa)" [class.selecionada]="recompensaSelecionada?.id === recompensa.id"
          onkeypress="true">
          <div class="header">
            <h4>{{ recompensa.titulo }}</h4>
          </div>

          <p class="descricao">
            {{ recompensa.descricao }}
          </p>

          <div class="footer">
            <span class="valor">
              {{ recompensa.valor | money }} Kz
            </span>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div class="flex justify-content-between gap-2">
    <p-button label="Cancelar" severity="secondary" (click)="closeDialogApoioManual()" onkeypress="true" />
    <p-button severity="success" (click)="SubmitApoioManual()" [disabled]="loading" onkeypress="true">
      {{ loading ? "Realizando apoio manual..." : "Realizar Apoio Manual" }}
      <i class="pi pi-spin pi-spinner" *ngIf="loading"></i>
    </p-button>
  </div>
</p-dialog>

<app-supender-campanha [campanhaID]="campanhaID" [visible]="showDialogSuspend" (onClose)="showDialogSuspend = false">
</app-supender-campanha>

<app-rejeitar-campanha [campanhaID]="campanhaID" [visible]="showRejeitCampanha" (onClose)="showRejeitCampanha = false">
</app-rejeitar-campanha>
<app-loader *ngIf="loading"></app-loader>